import type jsPDF from "jspdf";

export type PdfImage = { data: string; width: number; height: number };
export function hexRgb(hex: string): [number, number, number] {
  return [1, 3, 5].map(offset => parseInt(hex.slice(offset, offset + 2), 16)) as [number, number, number];
}
export function tintRgb(hex: string): [number, number, number] {
  return hexRgb(hex).map(value => Math.round(value * 0.09 + 255 * 0.91)) as [number, number, number];
}
export function fitImage(doc: jsPDF, image: PdfImage, x: number, y: number, w: number, h: number, alignment: "left" | "center" = "center") {
  const scale = Math.min(w / image.width, h / image.height);
  const iw = image.width * scale, ih = image.height * scale;
  doc.addImage(image.data, "PNG", alignment === "left" ? x : x + (w - iw) / 2, y + (h - ih) / 2, iw, ih);
}
export function text(doc: jsPDF, value: string, x: number, y: number, width: number, size: number, maxLines: number, bold = false, family = "helvetica"): number {
  doc.setFont(family, bold ? "bold" : "normal");
  doc.setFontSize(size);
  let lines = doc.splitTextToSize(value, width) as string[];
  if (lines.length > maxLines) {
    lines = lines.slice(0, maxLines);
    let last = lines[maxLines - 1];
    while (doc.getTextWidth(`${last}...`) > width && last.length) last = last.slice(0, -1);
    lines[maxLines - 1] = `${last}...`;
  }
  doc.text(lines, x, y, { lineHeightFactor: 1.3 });
  return y + lines.length * size * 0.3528 * 1.3;
}
